var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_vm._v(" Todos los derechos reservados. © Bien para Bien SAPI de C.V, SOFOM ENR. "+_vm._s(new Date().getFullYear())+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }